export const BOARD = 'board';
export const ISSUE = 'issue';
export const VERSION_DETAILS = 'version_details';
export const ISSUE_VIEW_CHILD_ISSUES_LIST = 'issue_view_child_issues_list';
export const ISSUE_VIEW_LINKED_ISSUES_LIST = 'issue_view_linked_issues_list';
